import SketchPad from './SketchPad'

export default SketchPad


// WEBPACK FOOTER //
// ./src/board/SketchPad/index.js